/**
 * Bug #438
 * @Author Anupama P
 * @Date 1 Jul 2021
 */
import { Button, Row } from './'

export default function SubmitButton({loading, label, className=null, ...props }) {
    return (
      // <Row style={{margin:"2px", marginTop:'20px'}}>{/** Bug #502 @Author Linda Susan Raju @Date 15 Jul 2021 */}
        <Button
        className={`btn-primary ${className}`}
        type="primary"
        htmlType="submit"
        size="large" 
        loading={loading}
        {...props}
      >
       {label}
      </Button>
      // </Row>
    )
}
/** End */